/**
 * Plan detail Benefits tab rules (DEV-229), kept pure so they are testable.
 *
 * The client plan Benefits tab edits plans.raw_benefits with the same
 * per-plan-type field set as the superadmin Plan Library
 * (shared/constants/benefitFieldTemplates.ts).
 */
import { getBenefitFieldTemplate } from "@shared/constants/benefitFieldTemplates";
import { isLifeDisabilityType } from "@shared/schemas/planTypes";

/**
 * Life / AD&D / STD / LTD plans used to hide the tab (their coverage lives in
 * Coverage Config). The Plan Library has benefit fields for them now, so the
 * tab shows whenever the type has a template; types without one (voluntary
 * life, generic "disability") keep it hidden as before.
 */
export function showsBenefitsTab(planType: string | null | undefined): boolean {
  return !isLifeDisabilityType(planType) || !!getBenefitFieldTemplate(planType);
}

/**
 * The Benefits card's subtitle. Employers never see internal wording such as
 * "Plan Library" / "Plan Builder" (DEV-379).
 */
export function benefitsTabDescription(opts: { isEmployer: boolean; canEdit: boolean }): string {
  if (opts.isEmployer) {
    return opts.canEdit
      ? "Benefit details for this plan, as your employees see them."
      : "Benefit details for this plan.";
  }
  return opts.canEdit
    ? "The same benefit fields as the Plan Builder. This is what employers and employees see for this plan."
    : "As entered in the Plan Library. This plan is managed by the platform, so its benefits are edited there.";
}

const GRID_COLS: Record<number, string> = {
  4: "grid-cols-4", 5: "grid-cols-5", 6: "grid-cols-6", 7: "grid-cols-7",
};
export function tabGridCols(tabCount: number): string {
  return GRID_COLS[tabCount] ?? "grid-cols-6";
}